import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa8a457"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "splash-view" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "options nav-list" }
const _hoisted_4 = { class: "audio-text" }

import {ref, computed, inject} from 'vue'
  import {useStore} from 'vuex'

  import SpriteIcon from '@/components/SpriteIcon'
  import IconButton from '@/components/inputs/IconButton'
  import ButtonInput from '@/components/inputs/ButtonInput'
  import ModalOverlay from '@/components/ModalOverlay'
  import ContentSection from '@/components/ContentSection'
  import CalledCoral from '@/components/CalledCoral'

  import {useRouter} from 'vue-router'
  import {usePreloader} from '@/lib/preloader'

  import {t} from '@/lib/i18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SplashView',
  setup(__props) {

  usePreloader()

  const store = useStore()
  const router = useRouter()
  const bus = inject('bus')

  const titleText = computed(() => t(store, 'social.title'))
  const introText = computed(() => t(store, 'splash.intro.1'))
  const introText2 = computed(() => t(store, 'chart.title'))

  const buttonText = computed(() => t(store, 'splash.enter'))
  const otherButtonText = computed(() => t(store, 'splash.other'))
  const audioText = computed(() => t(store, 'splash.audio'))
  //const cancelText = computed(() => t(store, 'splash.other.actions.cancel'))
  //const confirmText = computed(() => t(store, 'splash.other.actions.confirm'))
  //const scienceText = computed(() => t(store, 'splash.other.info'))
  //const showScience = ref(false)

  const audioLocations = store.state.audioLocations
  const translated = []
  audioLocations.forEach((item) => {
    translated.push({key: item.key, value: computed(() => t(store, item.key))})
  })

  //const errors = ref({})

  const onButtonClick = function () {
    store.state.selectedAudioLocation = 'selection.phillipines'
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click enter'
      }
    })
    router.push({name: 'active.alive'})
  }

  const onOtherButtonClick = function () {
    // showScience.value = true
    router.push('listen-selection')

    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click contribute more data'
      }
    })
  }

  /*
  const onScience = function () {
    router.push({name: 'active.listen'})
    //router.push({name: 'active.listen-selection'})
  }



  const onModalClose = () => {
    showScience.value = false
  }

  const onSubmit = () => {
    //router.push({name: 'active.science-intro-intro'})
    router.push({name: 'active.listen'})
  }
  */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ContentSection), { class: "title gradient-text content audio-warning" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(titleText)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(ContentSection), { class: "content bold audio-warning" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(introText)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(ContentSection), { class: "content bold audio-warning" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(introText2)), 1)
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_unref(IconButton), {
              name: "submit",
              class: "enter large",
              onClick: onButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(ButtonInput), {
              priority: "secondary",
              class: "science",
              onClick: onOtherButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(otherButtonText)), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_unref(ContentSection), { class: "content audio-warning" }, {
        default: _withCtx(() => [
          _createVNode(_unref(SpriteIcon), {
            name: "headphones",
            class: "icon"
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(audioText)), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(CalledCoral), { class: "shell" })
  ]))
}
}

})